module.exports = __webpack_public_path__ + "static/media/icon.306cfd87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.svg
// module id = 1006
// module chunks = 0